"use client"

import { Syllabus, Uuid } from "@/types"
import { FlattenedProgressMap } from "@/types"
import { User } from "@/schemas/User"
import { UserStatus } from "@/schemas/User"
import { LicenseType } from "@/schemas/User"
import { FlattenedBookmarksMap } from "@/types"
import { createStore } from "zustand/vanilla"
import { logger } from "@/utils/logger"

export type CourseState = {
  syllabuses: Syllabus[] | null
  progress: FlattenedProgressMap | null
  bookmarks: FlattenedBookmarksMap | null
  lastViewedSectionUuid: Uuid | null
  user: User | null
  userStatus: UserStatus | null
  licenseType: LicenseType | null
  envVars: {
    CAPTCHA_SITE_KEY: string
    CORE_API_ENDPOINT: string
    GA_MEASUREMENT_ID: string
    ASSETS_BUCKET: string
    DEMO_SIGN_UP_ENABLED: string
    DEMO_LABS_ENABLED: string
    SOCKET_PROXY_ENDPOINT: string
    BASE_URL: string
  }
  currentBreadcrumbs: string[] | null
}

export type CourseActions = {
  update: (storePartial: Partial<CourseState>) => void
}

export type CourseStore = CourseState & CourseActions

export const initCourseState = (): CourseState => {
  logger.debug("[Store:Data] Initialized")
  return {
    syllabuses: null,
    progress: null,
    bookmarks: null,
    lastViewedSectionUuid: null,
    user: null,
    userStatus: null,
    licenseType: null,
    envVars: null as unknown as CourseState["envVars"],
    currentBreadcrumbs: null,
  }
}

export const createCourseStore = (initState: CourseState = initCourseState()) => {
  return createStore<CourseStore>()((set) => ({
    ...initState,
    update: (storePartial: Partial<CourseState>) => {
      logger.debug("[Store:Data] Updated", storePartial)
      set((state) => ({ ...state, ...storePartial }))
    },
  }))
}
